/* istanbul ignore file */
import { ExperienceTemplateRenderer, ExperienceTemplateRendererContextProvider } from 'experience-template-renderer-react';
import { ExperimentStore } from 'bernie-plugin-mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { PageLayoutStore } from 'stores/page-layout/page-layout-store';

import { componentLibrary } from 'components/search/template-components';

interface TemplateRendererProps {
  pageLayout?: PageLayoutStore;
  experiment?: ExperimentStore;
}
export const TemplateRenderer: React.FC<TemplateRendererProps> = inject('pageLayout')(
  observer(({ pageLayout }) => (
    <ExperienceTemplateRendererContextProvider library={componentLibrary}>
      <ExperienceTemplateRenderer templateComponents={pageLayout?.getSRPTemplate(pageLayout?.templateName)?.components ?? []} />
    </ExperienceTemplateRendererContextProvider>
  ))
);
